import { useCallback, useState } from 'react'

export type TPPCellLinkTab = 'evidence' | 'activity' | 'valueMessage'

export type LockedObject = {
    lockedBy: { _id: string; name: string }
    lockedAt: string | Date
}

type Payload = {
    cellId: string
    cellContent: string
    linkedEvidence: object[]
    linkedActivities: object[]
    linkedValueMessages: object[]
    linkedKeyEvidenceStatement: object[]
}

export default function useTPPCellLinkModal() {
    const [isOpen, setIsOpen] = useState(false)
    const [tab, setTab] = useState<TPPCellLinkTab>('evidence')
    const [payload, setPayload] = useState<Payload | null>(null)

    const handleOpen = useCallback((nextTab: TPPCellLinkTab, nextPayload: Payload) => {
        setTab(nextTab)
        setPayload(nextPayload)
        setIsOpen(true)
    }, [])

    const handleClose = useCallback(() => {
        setIsOpen(false)
    }, [])

    return {
        isOpen,
        tab,
        payload,
        handleOpen,
        handleClose,
    }
}
